import { Component, OnInit, ChangeDetectorRef, WritableSignal, signal, NgZone } from '@angular/core';
import { EventServicesService } from 'src/app/services/event-services.service';
import { BreadcrumbService   } from 'xng-breadcrumb';
import { MessageService } from 'primeng/api';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { RoleServicesService } from 'src/app/services/role-services.service';
import { ActivatedRoute} from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { CountryStateCityService } from 'src/app/services/country-state-city.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { EmailServicesService } from 'src/app/services/email-services.service';
import { FormBuilderService } from 'src/app/services/form-builder.service';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

declare let tinymce: any;

type EventDetailsTabs = "overview" | "job-roles" | "access-management";

@Component({
    selector: 'app-event-details',
    templateUrl: './event-details.component.html',
    styleUrls: ['./event-details.component.css'],
    providers: [MessageService],
    standalone: false
})
export class EventDetailsComponent implements OnInit {

  isLoading: boolean = false;
  readMore: boolean = false;
  view_more_location: boolean = false;
  addEventSlider: boolean = false;
  showAddRole: boolean = false;
  showAssignUserDialog: boolean = false;
  assignDialogLoading: boolean = false;
  saveBtnLoading: boolean = false;
  hasFormChanges: boolean = false;
  hasJobRoleChanges: boolean = false;

  eventDetails: any = {};
  eventJobDetails: any = {};
  roleDetails: any = {};
  locationDetails: any[] = [];
  locationItems: Array<any> = [];
  jobRoleList: Array<any> = [];
  availableUsers: any[] = [];
  selectedUsers: any[] = [];
  assignedUsers: any[] = [];
  assignedRoles: any[] = []; // New: to match access-management component structure
  availableRoles: any[] = [];
  availableUsersForRole: any[] = [];
  selectedRoleForAssignment: any = null;
  
  // Delete confirmation properties
  showDeleteMemberModal: boolean = false;
  memberToDelete: any = null;
  isDeletingMember: boolean = false;
  dateFormat: any;
  userPrivilages: any;
  userRole: string = '';
  userPrivileges: Set<string> = new Set();
  eventId: string = '';
  jobId: string = '';
  locationsLength: number = 0;
  timeFormat: any;
  combineFormat: any;
  preparedRoleData: any = {};
  selectedLocationIndex: number = 0;
  
  // Form data for dropdowns (same as events-add)
  eventTypes: Array<any> = [];
  eventCategories: Array<any> = [];
  jobRoles: Array<any> = [];
  selectedJobRoles: any[] = [];
  selectedInstitutions: any[] = [];
  regForms: Array<any> = [];
  emailTemplates: Array<any> = [];
  institutions: any[] = [];
  clicked: boolean = false;

  // Job role specific data
  roleTypes: Array<any> = [];
  workModes: Array<any> = [
    { label: 'Remote', value: 'Remote' },
    { label: 'In Office', value: 'Office' },
    { label: 'Hybrid', value: 'Hybrid' },
  ];
  countries: Array<any> = [];
  states: Array<any> = [];
  cities: Array<any> = [];
  jsonData: any = {};
  
  // Filtered arrays for search functionality
  filteredCountries: Array<any> = [];
  filteredStates: Array<any> = [];
  filteredCities: Array<any> = [];
  
  // Dropdown selected values
  selectedRoleType: any = null;
  selectedWorkMode: any = null;
  selectedCountry: any = null;
  selectedState: any = null;
  selectedCity: any = null;
  selectedBusinessUnit: string = '';
  isUserChangingCountry: boolean = false;
  
  private originalJobRoleData: any = {};

  locationStates: Array<any>[] = [];
  locationCities: Array<any>[] = [];
  
  // TinyMCE editing state
  editingDescription: WritableSignal<boolean> = signal<boolean>(false);
  tinymce_api_key = environment.HOST.TINYMCE_API_KEY;

  currentTab: WritableSignal<EventDetailsTabs> = signal<EventDetailsTabs>("overview");

  eventDetailsForm: FormGroup = new FormGroup({
    eventTitle: new FormControl('', [Validators.required]),
    eventCategory: new FormControl('', [Validators.required]),
    eventType: new FormControl('', [Validators.required]),
    eventStartDate: new FormControl('', [Validators.required]),
    eventEndDate: new FormControl('', [Validators.required]),
    registrationStartDate: new FormControl('', [Validators.required]),
    registrationEndDate: new FormControl('', [Validators.required]),
    institutionName: new FormControl('', [Validators.required]),
    institutionAddress: new FormControl('', [Validators.required]),
    workExperience: new FormControl(0, [Validators.min(0)]),
    minSalary: new FormControl(0, [Validators.min(0)]),
    maxSalary: new FormControl(0, [Validators.min(0)]),
    jobRole: new FormControl([], [Validators.required]),
    reg_form_uuid: new FormControl('', [Validators.required]),
    email_template_id: new FormControl('', [Validators.required]),
    enableProctoring: new FormControl(false),
    photoCaptureMode: new FormControl('live')
  });

  jobRoleForm: FormGroup = new FormGroup({
    requirement: new FormControl(''),
    description: new FormControl(''),
    attachment: new FormControl('')
  });

  constructor(
    private eventServices: EventServicesService,
    private breadcrumbService: BreadcrumbService  ,
    private globalService: GlobalServicesService,
    private roleService: RoleServicesService,
    private jobService: JobServicesService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private sharedService: SharedServicesService,
    private countryStateCityService: CountryStateCityService,
    private emailServices: EmailServicesService,
    private formBuilderService: FormBuilderService,
    private ngZone: NgZone
    ) {
    this.locationItems = [
      { label: 'Country : ', field: 'country' },
      { label: 'State : ', field: 'state' },
      { label: 'City : ', field: 'city' },
      // For now hiring manager is commented out from event
      // { label: 'Hiring Manager : ', field: 'hire_manager_id' },
      { label: 'Business Unit : ', field: 'business_unit' },
      { label: 'Openings : ', field: 'opening' },
      { label: 'Maximum Applicants :', field: 'max_applicant' },
      { label: 'Diversity Male :', field: 'diversity_male' },
      { label: 'Diversity Female :', field: 'diversity_female' },
      { label: 'Diversity Other :', field: 'diversity_other' },
    ]
  }

  ngOnInit(): void {
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
    this.timeFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.time_format : '';
    this.combineFormat = this.timeFormat == 'hh:mm' ? this.dateFormat  + '  '+ this.timeFormat + ' a' : this.dateFormat  + '  '+ this.timeFormat;
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });    
    this.activatedRoute.params.subscribe(params => {
      const newEventId = params["eventId"];
      const sharedService = this.globalService.getSharedService();
      this.eventId = newEventId;
      const cachedEventData = sharedService.getEventDetails(this.eventId);
      if (cachedEventData && cachedEventData.event_details) {
        this.handleEventDetails(cachedEventData.event_details);
      } else {
        this.getEventDetails();
      }

    });
    
    // Load form data for dropdowns
    this.getFormData();

    // Add event type change listener
    this.eventDetailsForm.get('eventType')?.valueChanges.subscribe(() => {
      this.onEventTypeChange();
    });
    this.eventDetailsForm.valueChanges.subscribe(() => {
      this.hasFormChanges = this.eventDetailsForm.dirty;
    });

    this.jobRoleForm.valueChanges.subscribe(() => {
      this.hasJobRoleChanges = this.jobRoleForm.dirty;
    });
  }

  getFormData = async () => {
    try {
      const response = await this.eventServices.getEventFormDataFastApi().toPromise();

      if (response && response.status === 200 && response.body) {
        this.jobRoles = response.body.job_roles;
        this.emailTemplates = response.body.email_templates;
        this.eventCategories = response.body.event_categories;
        this.eventTypes = response.body.event_types;
        this.institutions = response.body.institutes;
        this.regForms = response.body.forms;
      }
    } catch (error) {
      console.error('Error fetching form data:', error);
    }
  };

  getJobRoleFormData = async () => {
    try {
      const response = await this.roleService.getJobRolesFormDataFastApi().toPromise();
      if (response && response.status === 200 && response.body) {
        this.roleTypes = response.body.role_types.map((element: any) => ({
          label: element.name,
          value: element.id
        }));
      }
    } catch (error) {
      console.error('Error fetching job role form data:', error);
    }
  };

  loadCountryStateCityData() {
    this.countryStateCityService.getCountryStateCityData().subscribe(data => {
      this.jsonData = data;
      this.loadCountries();
    });
  }

  loadCountries() {
    this.countries = Object.keys(this.jsonData).map(country => ({
      label: country,
      value: country
    }));
    this.filteredCountries = [...this.countries];
  }

  onEventTypeChange() {
    const selectedEventType = this.getSelectedEventType();
    const institutionNameControl = this.eventDetailsForm.get('institutionName');
    const institutionAddressControl = this.eventDetailsForm.get('institutionAddress');
    const currentValue = institutionNameControl?.value;

    if (!institutionNameControl || !institutionAddressControl) return;

    if (selectedEventType?.institution_select_type === 'not_applicable') {
      institutionNameControl.clearValidators();
      institutionAddressControl.clearValidators();
      Promise.resolve().then(() => institutionNameControl.setValue([]));
    } else if (selectedEventType?.institution_select_type === 'single') {
      institutionNameControl.setValidators([Validators.required]);
      institutionAddressControl.setValidators([Validators.required]);
      
      const singleValue = Array.isArray(currentValue) ? (currentValue.length > 0 ? currentValue[0] : null) : currentValue;
      Promise.resolve().then(() => institutionNameControl.setValue(singleValue));
    } else {
      // Multiple select case
      institutionNameControl.setValidators([Validators.required]);
      institutionAddressControl.setValidators([Validators.required]);
      const arrayValue = Array.isArray(currentValue) ? currentValue : (currentValue ? [currentValue] : []);
      Promise.resolve().then(() => institutionNameControl.setValue(arrayValue));
    }

    institutionNameControl.updateValueAndValidity();
    institutionAddressControl.updateValueAndValidity();
    this.eventDetailsForm.markAsDirty();
    this.cdr.detectChanges();
  }

  getSelectedEventType() {
    const selectedId = this.eventDetailsForm.value.eventType;
    return this.eventTypes.find(eventType => eventType.id === selectedId);
  }

  onLocationChange(event: any) {
    this.selectedLocationIndex = event.value;
    if (this.roleDetails.locations && this.roleDetails.locations[this.selectedLocationIndex]) {
      this.locationDetails = [this.roleDetails.locations[this.selectedLocationIndex]];
      
      // Update the current location data for display
      const selectedLocation = this.roleDetails.locations[this.selectedLocationIndex];
      this.selectedCountry = selectedLocation.country;
      this.selectedState = selectedLocation.state;
      this.selectedCity = Array.isArray(selectedLocation.city) ? selectedLocation.city[0] : selectedLocation.city;
      this.selectedBusinessUnit = selectedLocation.business_unit || '';

      if (selectedLocation.country) {
        this.loadCountryData(selectedLocation.country);
        if (selectedLocation.state) {
          this.loadStateData(selectedLocation.state, selectedLocation.country);
        }
      } else {
        this.states = [];
        this.cities = [];
        this.filteredStates = [];
        this.filteredCities = [];
      }      
      this.cdr.detectChanges();
    }
  }

  saveCurrentLocationData() {
    if (this.roleDetails.locations && this.roleDetails.locations[this.selectedLocationIndex]) {
      const currentLocation = this.roleDetails.locations[this.selectedLocationIndex];
      const formValue = this.jobRoleForm.value;
      if (formValue) {
        currentLocation.opening = formValue.opening || currentLocation.opening || 0;
        currentLocation.max_applicant = formValue.max_applicant || currentLocation.max_applicant || 0;
        currentLocation.diversity_male = formValue.diversity_male || currentLocation.diversity_male || 0;
        currentLocation.diversity_female = formValue.diversity_female || currentLocation.diversity_female || 0;
        currentLocation.diversity_other = formValue.diversity_other || currentLocation.diversity_other || 0;
      }
    }
  }

  getCurrentLocationData() {

    if (this.roleDetails.locations && this.roleDetails.locations[this.selectedLocationIndex]) {
      const currentLocation = this.roleDetails.locations[this.selectedLocationIndex];
      return {
        country: currentLocation.country || '',
        state: currentLocation.state || '',
        city: currentLocation.city || '',
        business_unit: currentLocation.business_unit || ''
      };
    }
    return {
      country: '',
      state: '',
      city: '',
      business_unit: ''
    };
  }

  updateLocationField(field: string, value: any) {

    if (this.roleDetails.locations && this.roleDetails.locations[this.selectedLocationIndex]) {
      const currentLocation = this.roleDetails.locations[this.selectedLocationIndex];
      currentLocation[field] = value;
      

      this.selectedCountry = currentLocation.country;
      this.selectedState = currentLocation.state;
      this.selectedCity = currentLocation.city;
      this.selectedBusinessUnit = currentLocation.business_unit;
      this.jobRoleForm.markAsDirty();
      this.cdr.detectChanges();
    }
  }

  getLocationOptions() {
    if (!this.roleDetails.locations || !Array.isArray(this.roleDetails.locations)) {
      return [];
    }
    
    return this.roleDetails.locations.map((location: any, index: number) => ({
      label: `Location ${index + 1}`,
      value: index
    }));
  }
  openAddRole() {
    this.preparedRoleData = { ...this.roleDetails, isUpdate: true };
    this.showAddRole = true;
  }  
  getEventDetails = () => {
    const sharedService = this.globalService.getSharedService();
    const request = sharedService.initiateEventDetailsRequest(
      this.eventId, 
      () => this.eventServices.getSpecificEventFastApi(this.eventId)
    );
    if (!request) {
      this.isLoading = false;
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Failed to initiate event details request",
      });
      return;
    }
  
    this.isLoading = true;
    request.subscribe({
      next: (response: any) => {
        const fullEventData = response?.body ?? response;
        if (!sharedService.isEventDetailsLoaded(this.eventId)) {
          sharedService.setEventDetails(this.eventId, fullEventData);
        }
        this.handleEventDetails(fullEventData.event_details);
        this.isLoading = false;
      },
      error: (_err: any) => {
        this.isLoading = false;
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Error fetching event details",
        });
      },
    });
  }

  handleEventDetails(eventDetails: any) {
    this.eventDetails = { ...eventDetails, id: eventDetails.uuid };
    this.cdr.detectChanges();
    this.eventDetails.id = this.eventDetails.uuid;
    const _jobRoles =
      this.eventDetails.job_roles && this.eventDetails.job_roles.length > 0 ? this.eventDetails.job_roles : []
    this.jobRoleList = _jobRoles.map((role: any) => ({ roleName: role.name, roleId: role.id, isActive: false }))
    if (this.jobRoleList.length > 0) {
      this.jobRoleList[0].isActive = true
      // Only load job roles when Job Roles tab is active
      if (this.currentTab() === 'job-roles') {
      this.getJobRoles(this.jobRoleList[0].roleId)
      }
    }
    
    // Populate the form with event details after ensuring institutions are loaded
    this.populateFormWithInstitutions();
    
    // Update just the event breadcrumb alias label
    this.breadcrumbService.set('@event', this.eventDetails.name);
  
    localStorage.setItem("selectedEventName", this.eventDetails.name);
  }
  

  getJobRoles = (eventId: string) => {
    this.isLoading = true;
    this.roleService.getSpecificJobRolesFastApi(eventId).subscribe({
      next: (response: any) => {
        setTimeout(() => {
          this.roleDetails = response.body ? response.body : [];
          this.locationsLength = this.roleDetails.locations?.length;
          this.locationDetails = Array.isArray(this.roleDetails.locations) ? this.roleDetails.locations.slice(0, 1) : [];
          this.selectedLocationIndex = 0; // Reset to first location
          
          this.populateJobRoleForm();
          this.loadLocationData(); // Load country/state/city data
          
          // Initialize location arrays for multiple locations after data is loaded
          setTimeout(() => {
            this.initializeLocationArrays();
            
            // If there are multiple locations, ensure the first one is selected
            if (this.roleDetails.locations && this.roleDetails.locations.length > 0) {
              this.selectedLocationIndex = 0;
              this.onLocationChange({ value: 0 });
            }
          }, 100);
          
          this.isLoading = false;
          this.cdr.detectChanges();
        });
      },
      error: (_err: any) => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  };

  initializeLocationArrays() {
    if (this.roleDetails.locations && this.roleDetails.locations.length > 0) {
      this.locationStates = [];
      this.locationCities = [];
      
      this.roleDetails.locations.forEach((location: any, index: number) => {
        this.locationStates[index] = [];
        this.locationCities[index] = [];
        
        // Load states and cities for existing locations
        if (location.country) {
          // Load states for this country
          if (this.jsonData && this.jsonData[location.country]) {
            this.locationStates[index] = Object.keys(this.jsonData[location.country]).map(state => ({
              label: state,
              value: state
            }));
          }
          
          // Load cities for this state
          if (location.state && this.jsonData && this.jsonData[location.country] && this.jsonData[location.country][location.state]) {
            this.locationCities[index] = this.jsonData[location.country][location.state].map((city: string) => ({
              label: city,
              value: city
            }));
          }
          
          // Handle city as array - take first element if it's an array
          if (location.city && Array.isArray(location.city) && location.city.length > 0) {
            location.city = location.city[0];
          }
        }
      });
    } else {
      // Initialize empty arrays if no locations
      this.locationStates = [];
      this.locationCities = [];
    }
  }
  

  openRole = (id: string) => {
    setTimeout(() => {
      // Reset location dropdowns before loading new role data
      this.selectedCountry = null;
      this.selectedState = null;
      this.selectedCity = null;
      this.states = [];
      this.cities = [];
      
      this.jobRoleList.forEach((role: any) => {
        if (role.roleId === id) {
          role.isActive = true;
        } else {
          role.isActive = false;
        }
      });
      this.getJobRoles(id);
      this.cdr.detectChanges();
    });
  }
  onCloseEventSlider(closed: boolean) {
    if (closed) {
      this.addEventSlider = false;
      const sharedService = this.globalService.getSharedService();
      sharedService.clearEventDetails(this.eventId);
      this.getEventDetails();
    }
  }
  onRoleUpdateSuccess() {
    this.showAddRole = false;
    const activeRole = this.jobRoleList.find(role => role.isActive);
    if (activeRole) {
      this.getJobRoles(activeRole.roleId);
    }
  }

  switchCurrentTab(tab: EventDetailsTabs) {
    if (this.currentTab() === 'overview' && tab !== 'overview' && this.hasFormChanges) {
      this.resetOverviewForm();
    }    
    if (this.currentTab() === 'job-roles' && tab !== 'job-roles' && this.checkJobRoleChanges()) {
      this.resetJobRoleForm();
    }
    
    this.currentTab.set(tab);
    
    // Load job roles when switching to Job Roles tab
    if (tab === 'job-roles') {
      // Load job role form data if not already loaded
      if (this.roleTypes.length === 0) {
        this.getJobRoleFormData();
      }
      if (this.countries.length === 0) {
        this.loadCountryStateCityData();
      }
      
      if (this.jobRoleList.length > 0) {
        const activeRole = this.jobRoleList.find(role => role.isActive);
        if (activeRole) {
          this.getJobRoles(activeRole.roleId);
        }
      }
    }
    
    // Load access management data when switching to Access Management tab
    if (tab === 'access-management') {
      this.loadAccessManagementData();
    }
  }

  populateFormWithInstitutions() {
    // If institutions are already loaded, populate form immediately
    if (this.institutions && this.institutions.length > 0) {
      this.populateForm();
    } else {
      // Wait for institutions to load, then populate form
      const checkInstitutions = () => {
        if (this.institutions && this.institutions.length > 0) {
          this.populateForm();
        } else {
          setTimeout(checkInstitutions, 100);
        }
      };
      checkInstitutions();
    }
  }

  populateForm() {
    if (this.eventDetails) {
      // First set the event type to trigger validation logic
      this.eventDetailsForm.patchValue({
        eventType: this.eventDetails.event_type?.id || ''
      });

      // Wait for event type change to complete, then set other values
      setTimeout(() => {
        const selectedEventType = this.getSelectedEventType();
        const institutionNameControl = this.eventDetailsForm.get('institutionName');
        const institutionAddressControl = this.eventDetailsForm.get('institutionAddress');

        // Clear validators first
        institutionNameControl?.clearValidators();
        institutionAddressControl?.clearValidators();

        // Set institution value based on event type
        let institutionValue = null;
        if (this.eventDetails.institutes?.length > 0) {
          if (selectedEventType?.institution_select_type === 'single') {
            // For single select, use single value (not array)
            institutionValue = this.eventDetails.institutes[0].id;
          } else {
            // For multiple select, use array
            institutionValue = this.eventDetails.institutes.map((inst: any) => inst.id);
          }
          
        }

        this.eventDetailsForm.patchValue({
          eventTitle: this.eventDetails.name || '',
          eventCategory: this.eventDetails.event_category?.id || '',
          eventStartDate: this.eventDetails.event_start_date ? new Date(this.eventDetails.event_start_date) : null,
          eventEndDate: this.eventDetails.event_end_date ? new Date(this.eventDetails.event_end_date) : null,
          registrationStartDate: this.eventDetails.registration_start_date ? new Date(this.eventDetails.registration_start_date) : null,
          registrationEndDate: this.eventDetails.registration_end_date ? new Date(this.eventDetails.registration_end_date) : null,
          institutionName: institutionValue,
          institutionAddress: this.eventDetails.institution_address || '',
          workExperience: this.eventDetails.work_experience || 0,
          minSalary: this.eventDetails.min_salary || 0,
          maxSalary: this.eventDetails.max_salary || 0,
          jobRole: this.eventDetails.job_roles?.map((role: any) => role.id) || [],
          reg_form_uuid: this.eventDetails.form?.uuid || '',
          email_template_id: this.eventDetails.email_template?.id || '',
          enableProctoring: this.eventDetails.proctoring_config?.enabled ?? false,
          photoCaptureMode: this.eventDetails.proctoring_config?.mode ?? 'live'
        });

        // Set validators based on event type
        if (selectedEventType?.institution_select_type === 'single' || 
            selectedEventType?.institution_select_type === 'multiple') {
          institutionNameControl?.setValidators([Validators.required]);
          institutionAddressControl?.setValidators([Validators.required]);
        }

        institutionNameControl?.updateValueAndValidity();
        institutionAddressControl?.updateValueAndValidity();
        
        // Update selected arrays for UI
        this.selectedJobRoles = this.eventDetails.job_roles || [];
        this.selectedInstitutions = this.eventDetails.institutes || [];
        
        this.eventDetailsForm.markAsPristine();
        this.hasFormChanges = false;
      }, 100);
    }
  }

  populateJobRoleForm() {
    if (this.roleDetails) {
      this.jobRoleForm.patchValue({
        requirement: this.roleDetails.requirement || '',
        description: this.roleDetails.description || '',
        attachment: this.roleDetails.attachment || ''
      });

      if (this.editingDescription()) {
        this.syncDescriptionEditorContent();
      }
      // Set selected values for dropdowns
      this.selectedRoleType = this.roleDetails.role_type?.id || null;
      this.selectedWorkMode = this.roleDetails.work_mode || null;
      
      // Set location values if available
      if (this.locationDetails && this.locationDetails.length > 0) {
        const location = this.locationDetails[0];
        this.selectedCountry = location.country || null;
        this.selectedState = location.state || null;
        this.selectedCity = Array.isArray(location.city) ? location.city[0] : location.city || null;
        this.selectedBusinessUnit = location.business_unit || '';
      }
      
      this.originalJobRoleData = {
        roleType: this.selectedRoleType,
        workMode: this.selectedWorkMode,
        country: this.selectedCountry,
        state: this.selectedState,
        city: this.selectedCity,
        businessUnit: this.selectedBusinessUnit
      };
      

      this.jobRoleForm.markAsPristine();
      this.hasJobRoleChanges = false;
    }
  }

  cancelEdit() {
    this.eventDetailsForm.reset();
    this.populateFormWithInstitutions();
    this.hasFormChanges = false;
  }

  checkJobRoleChanges(): boolean {
    const formChanged = this.jobRoleForm.dirty;
    
    const dropdownChanged = 
      this.selectedRoleType !== this.originalJobRoleData.roleType ||
      this.selectedWorkMode !== this.originalJobRoleData.workMode ||
      this.selectedCountry !== this.originalJobRoleData.country ||
      this.selectedState !== this.originalJobRoleData.state ||
      this.selectedCity !== this.originalJobRoleData.city ||
      this.selectedBusinessUnit !== this.originalJobRoleData.businessUnit;
    
    const hasChanges = formChanged || dropdownChanged;
    if (!hasChanges) {
      return false;
    }
    
    const mandatoryFieldsValid = this.validateJobRoleMandatoryFields();
    return hasChanges && mandatoryFieldsValid;
  }

  validateJobRoleMandatoryFields(): boolean {

    const currentLocationData = this.getCurrentLocationData();
    const roleTypeValid = this.selectedRoleType && this.selectedRoleType !== null;
    const workModeValid = this.selectedWorkMode && this.selectedWorkMode !== null;
    const countryValid = !!(currentLocationData.country && String(currentLocationData.country).trim() !== '');
    const stateValid = !!(currentLocationData.state && String(currentLocationData.state).trim() !== '');
    const cityValue: any = currentLocationData.city;
    const cityValid = Array.isArray(cityValue)
      ? cityValue.length > 0 && String(cityValue[0] ?? '').trim() !== ''
      : !!(cityValue && String(cityValue).trim() !== '');
    const businessUnitValid = !!(currentLocationData.business_unit && String(currentLocationData.business_unit).trim() !== '');
    
    return roleTypeValid && workModeValid && countryValid && stateValid && cityValid && businessUnitValid;
  }

  private buildPhotoCaptureConfig() {
    const enabled = this.eventDetailsForm.get('enableProctoring')?.value ?? false;
    return {
      enabled,
      mode: enabled ? (this.eventDetailsForm.get('photoCaptureMode')?.value ?? 'live') : null,
    };
  }

  /** Submit guard — blocks save when proctoring needs a mandatory Photo field. */
  private async ensureProctoringPhotoField(): Promise<boolean> {
    const warning = await firstValueFrom(this.formBuilderService.proctoringPhotoFieldWarning(
      this.eventDetailsForm.get('enableProctoring')?.value,
      this.eventDetailsForm.get('reg_form_uuid')?.value
    ));
    if (warning) {
      this.messageService.add({ severity: 'warn', summary: 'Photo field required', detail: warning });
      return false;
    }
    return true;
  }

  async saveEventDetails() {
    this.clicked = true;
    
    if (!this.hasFormChanges) {
      this.messageService.add({
        severity: 'info',
        summary: 'No Changes',
        detail: 'No changes have been made to save'
      });
      this.clicked = false;
      return;
    }
    

    const fieldsToCheck = ['eventTitle', 'institutionAddress'];
    if (this.sharedService.hasSecurityViolations(this.eventDetailsForm, fieldsToCheck)) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      this.clicked = false;
      return;
    }
    
    if (!this.eventDetailsForm.valid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill all required fields'
      });
      this.clicked = false;
      return;
    }


    const isTemplateValid = await this.validateEmailTemplate();
    if (!isTemplateValid) {
      this.clicked = false;
      return;
    }

    const photoFieldValid = await this.ensureProctoringPhotoField();
    if (!photoFieldValid) {
      this.clicked = false;
      return;
    }

    this.saveBtnLoading = true;
    const secureFormValue = this.sharedService.getSecurePayload(this.eventDetailsForm.value);
    
    // Create payload using same structure as events-add component
    const eventType = this.getSelectedEventType();
    const institutionValue = this.eventDetailsForm.controls['institutionName'].value;
    const institutionAddress = secureFormValue.institutionAddress;
    
    let institutes = [];
    if (institutionValue) {
      institutes = Array.isArray(institutionValue) ? institutionValue : [institutionValue];
    }
    
    const payload = {
      name: secureFormValue.eventTitle,
      event_start_date: secureFormValue.eventStartDate,
      event_end_date: secureFormValue.eventEndDate,
      job_roles: secureFormValue.jobRole,
      work_experience: secureFormValue.workExperience,
      min_salary: secureFormValue.minSalary,
      max_salary: secureFormValue.maxSalary,
      event_category_id: secureFormValue.eventCategory,
      event_type_id: secureFormValue.eventType,
      registration_start_date: secureFormValue.registrationStartDate,
      registration_end_date: secureFormValue.registrationEndDate,
      form_uuid: secureFormValue.reg_form_uuid,
      email_template_id: secureFormValue.email_template_id,
      institution_address: eventType?.institution_select_type === 'not_applicable' 
        ? (institutionAddress || null)
        : institutionAddress,
      institutes: eventType?.institution_select_type === 'not_applicable'
        ? (institutes.length ? institutes : [])
        : institutes,
      proctoring_config: this.buildPhotoCaptureConfig(),
    };

    // Call the same API as events-add component
    this.eventServices.updateEventFastApi(payload, this.eventId).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: response.body.detail
          });
          
          // Update local eventDetails object to persist UI changes
          this.eventDetails = {
            ...this.eventDetails,
            name: secureFormValue.eventTitle,
            event_start_date: secureFormValue.eventStartDate,
            event_end_date: secureFormValue.eventEndDate,
            registration_start_date: secureFormValue.registrationStartDate,
            registration_end_date: secureFormValue.registrationEndDate,
            institution_address: secureFormValue.institutionAddress,
            work_experience: secureFormValue.workExperience,
            min_salary: secureFormValue.minSalary,
            max_salary: secureFormValue.maxSalary,
            // Update nested objects
            event_category: this.eventCategories.find(cat => cat.id === secureFormValue.eventCategory),
            event_type: this.eventTypes.find(type => type.id === secureFormValue.eventType),
            job_roles: this.jobRoles.filter(role => secureFormValue.jobRole.includes(role.id)),
            institutes: this.institutions.filter(inst => {
              const institutionValue = secureFormValue.institutionName;
              return Array.isArray(institutionValue) 
                ? institutionValue.includes(inst.id)
                : institutionValue === inst.id;
            }),
            form: this.regForms.find(form => form.uuid === secureFormValue.reg_form_uuid),
            email_template: this.emailTemplates.find(template => template.id === secureFormValue.email_template_id)
          };
          
          this.saveBtnLoading = false;
          this.clicked = false;
          this.eventDetailsForm.markAsPristine();
          this.hasFormChanges = false;
          


          const sharedService = this.globalService.getSharedService();
          sharedService.clearEventDetails(this.eventId);
          this.getEventDetails();
        }
      },
      error: (error) => {
        this.saveBtnLoading = false;
        this.clicked = false;
      }
    });
  }

  saveJobRoleDetails() {
    if (!this.checkJobRoleChanges()) {
      this.messageService.add({
        severity: 'info',
        summary: 'No Changes',
        detail: 'No changes have been made to save'
      });
      return;
    }

    if (!this.jobRoleForm.valid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill all required fields'
      });
      return;
    }

    this.saveBtnLoading = true;
    const formValue = this.jobRoleForm.value;
    const activeRole = this.jobRoleList.find(role => role.isActive);
    
    if (!activeRole) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No active role selected'
      });
      this.saveBtnLoading = false;
      return;
    }

    this.saveCurrentLocationData();

    // Get TinyMCE content if editor is active
    let descriptionContent = formValue.description || '';
    if (typeof tinymce !== 'undefined' && tinymce.activeEditor && this.editingDescription()) {
      descriptionContent = tinymce.activeEditor.getContent();
    }

    const attachmentValue = formValue.attachment || this.roleDetails.attachment || '';
    const attachmentFileName = attachmentValue ? this.getAttachmentName(attachmentValue) : '';

    const payload = {
      name: this.roleDetails.name,
      role_type_id: this.selectedRoleType || this.roleDetails.role_type?.id,
      requirement: formValue.requirement || this.roleDetails.requirement || '',
      description: descriptionContent || this.roleDetails.description || '',
      attachment: attachmentFileName,
      work_mode: this.selectedWorkMode || this.roleDetails.work_mode,
      locations: this.roleDetails.locations?.map((location: any) => ({
        country: location.country || '',
        state: location.state || '',
        city: Array.isArray(location.city) ? location.city : [location.city],
        hire_manager_id: location.hire_manager_id || null,
        business_unit: location.business_unit || '',
        opening: location.opening !== null && location.opening !== undefined ? location.opening : 0,
        max_applicant: location.max_applicant !== null && location.max_applicant !== undefined ? location.max_applicant : 0,
        diversity_male: location.diversity_male !== null && location.diversity_male !== undefined ? location.diversity_male : 0,
        diversity_female: location.diversity_female !== null && location.diversity_female !== undefined ? location.diversity_female : 0,
        diversity_other: location.diversity_other !== null && location.diversity_other !== undefined ? location.diversity_other : 0,
      })) || []
    };
    
    // Call the job role update API here
    this.roleService.updateJobRolesFastApi(activeRole.roleId, payload).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Job role details updated successfully'
        });
        
        // Update local roleDetails object to persist UI changes
        this.roleDetails = {
          ...this.roleDetails,
          requirement: formValue.requirement,
          description: descriptionContent,
          attachment: formValue.attachment,
          role_type: this.roleTypes.find(rt => rt.value === this.selectedRoleType),
          work_mode: this.selectedWorkMode
        };
        
        this.saveBtnLoading = false;
        this.jobRoleForm.markAsPristine();
        this.hasJobRoleChanges = false;
        this.editingDescription.set(false);        
        this.originalJobRoleData = {
          roleType: this.selectedRoleType,
          workMode: this.selectedWorkMode,
          country: this.selectedCountry,
          state: this.selectedState,
          city: this.selectedCity,
          businessUnit: this.selectedBusinessUnit
        };
      },
      error: (error) => {
        this.saveBtnLoading = false;
      }
    });
  }

  openAssignUserDialog() {
    this.showAssignUserDialog = true;
    this.selectedRoleForAssignment = null;
    this.selectedUsers = [];
    this.availableUsersForRole = [];
    this.loadAvailableRoles();
  }

  loadAccessManagementData() {
    this.isLoading = true;
    this.jobService.getSpecificEventFastApi(this.eventId).subscribe({
      next: (response: any) => {
        const data = response.body;
        
        if (data && data.manage_access && data.manage_access.length > 0) {
          // Convert manage_access data to assignedRoles format (like access-management component)
          this.assignedRoles = data.manage_access.map((role: any) => ({
            id: role.role_id,
            name: role.role_name,
            description: `Manage ${role.role_name?.toLowerCase()} responsibilities`,
            users: role.users || []
          }));
          
          // Also populate assignedUsers for display
          this.assignedUsers = [];
          this.assignedRoles.forEach((role: any) => {
            if (role.users && role.users.length > 0) {
              role.users.forEach((user: any) => {
                this.assignedUsers.push({
                  id: user.id,
                  name: `${user.first_name} ${user.last_name}`,
                  email: user.email,
                  initials: `${user.first_name[0]}${user.last_name[0]}`.toUpperCase(),
                  role: role.name
                });
              });
            }
          });
        } else {
          this.assignedRoles = [];
          this.assignedUsers = [];
        }
        
        this.isLoading = false;
      },
      error: (error: any) => {
        this.assignedRoles = [];
        this.assignedUsers = [];
        this.isLoading = false;
      }
    });
  }

  loadAvailableRoles() {
    this.isLoading = true;
    // Load roles from the role service
    this.roleService.getRoleAndPermissionFastApi().subscribe({
      next: (response: any) => {
        const rolesData = response.body || [];
        this.availableRoles = rolesData
          .map((role: any) => ({
            id: role.id,
            name: role.name,
            description: role.description
          }));
        this.isLoading = false;
      },
      error: (error: any) => {
        this.isLoading = false;
      }
    });
  }

  onRoleSelectionChange(event: any) {
    this.selectedRoleForAssignment = event.value;
    this.selectedUsers = [];
    if (this.selectedRoleForAssignment) {
      this.loadUsersForSelectedRole();
    } else {
      this.availableUsersForRole = [];
    }
  }

  loadAllUsers() {
    this.assignDialogLoading = true;
    this.jobService.getUsersFastApi(1, 100).subscribe({
      next: (response: any) => {
        const usersData = response.body || {};
        const allUsers = usersData.items || [];
        
        // Get all assigned user IDs from all roles
        const assignedUserIds = new Set<number>();
        this.assignedRoles.forEach(role => {
          if (role.users) {
            role.users.forEach((user: any) => {
              assignedUserIds.add(user.id);
            });
          }
        });
        
        // Filter out already assigned users
        const availableUsers = allUsers.filter((user: any) => !assignedUserIds.has(user.id));
        
        this.availableUsersForRole = availableUsers.map((user: any) => ({
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
          email: user.email,
          initials: `${user.first_name[0]}${user.last_name[0]}`.toUpperCase(),
          role: user.role?.name || 'No Role'
        }));
        
        this.assignDialogLoading = false;
      },
      error: (error: any) => {
        this.assignDialogLoading = false;
        this.availableUsersForRole = [];
      }
    });
  }

  loadUsersForSelectedRole() {
    if (!this.selectedRoleForAssignment) return;
    
    this.assignDialogLoading = true;
    this.jobService.getUsersFastApi(1, 100).subscribe({
      next: (response: any) => {
        const usersData = response.body || {};
        const allUsers = usersData.items || [];
        
        // Get all assigned user IDs from all roles
        const assignedUserIds = new Set<number>();
        this.assignedRoles.forEach(role => {
          if (role.users) {
            role.users.forEach((user: any) => {
              assignedUserIds.add(user.id);
            });
          }
        });
        
        // Filter users by selected role and exclude already assigned users
        const usersWithSelectedRole = allUsers.filter((user: any) => 
          user.role && user.role.id === this.selectedRoleForAssignment && !assignedUserIds.has(user.id)
        );
        
        this.availableUsersForRole = usersWithSelectedRole.map((user: any) => ({
          id: user.id,
          name: `${user.first_name} ${user.last_name}`,
          email: user.email,
          initials: `${user.first_name[0]}${user.last_name[0]}`.toUpperCase(),
          role: user.role.name
        }));
        
        this.assignDialogLoading = false;
      },
      error: (error: any) => {
        this.assignDialogLoading = false;
        this.availableUsersForRole = [];
      }
    });
  }

  closeAssignUserDialog() {
    this.showAssignUserDialog = false;
    this.selectedUsers = [];
    this.selectedRoleForAssignment = null;
    this.availableUsersForRole = [];
  }

  assignUsers() {
    if (this.selectedUsers.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select at least one user'
      });
      return;
    }

    if (!this.selectedRoleForAssignment) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select a role first'
      });
      return;
    }

    this.isLoading = true;
    
    // Get newly selected user IDs (same logic as access-management component)
    const newlySelectedUserIds = this.availableUsersForRole
      .filter(user => this.selectedUsers.includes(user.id))
      .map(user => parseInt(user.id));
      
    const allExistingUserIds: number[] = [];
    
    // Collect all existing users from all roles (same logic as access-management component)
    this.assignedRoles.forEach(role => {
      if (role.id === this.selectedRoleForAssignment) {
        // For the current role, merge existing users with newly selected users
        const existingUserIds = role.users.map((user: any) => user.id);
        const mergedUserIds = Array.from(new Set([...existingUserIds, ...newlySelectedUserIds]));
        allExistingUserIds.push(...mergedUserIds);
      } else {
        // For other roles, keep all existing users
        const existingUserIds = role.users.map((user: any) => user.id);
        allExistingUserIds.push(...existingUserIds);
      }
    });  
    
    // Handle case where this is a new role (not in assignedRoles yet)
    const isNewRole = !this.assignedRoles.some(role => role.id === this.selectedRoleForAssignment);
    if (isNewRole) {
      allExistingUserIds.push(...newlySelectedUserIds);
    }  
    
    const uniqueUserIds = Array.from(new Set(allExistingUserIds));
    
    const payload = [
      {
        user_id: uniqueUserIds
      }
    ];



    // Make API call to assign users to role
    this.jobService.addMembersToRole(this.eventId, this.selectedRoleForAssignment, payload).subscribe({
      next: (response: any) => {
        
        // Reload access management data to get updated state
        this.loadAccessManagementData();

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `${this.selectedUsers.length} users assigned successfully`
        });
        
        this.closeAssignUserDialog();
        this.isLoading = false;
      },
      error: (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to assign users. Please try again.'
        });
        this.isLoading = false;
      }
    });
  }

  confirmDeleteMember(user: any): void {
    this.memberToDelete = user;
    this.showDeleteMemberModal = true;
  }

  closeDeleteMemberModal(): void {
    this.showDeleteMemberModal = false;
    this.memberToDelete = null;
    this.isDeletingMember = false;
  }

  removeUser(user: any) {
    if (!user || !user.id) return;
    
    this.isDeletingMember = true;
    
    // Find the role that contains this user by searching in assignedRoles
    const userRole = this.assignedRoles.find(role => 
      role.users && role.users.some((u: any) => u.id === user.id)
    );
    
    if (!userRole) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Could not find role for user'
      });
      this.isDeletingMember = false;
      return;
    }
    
    const roleId = userRole.id;
    
    const allExistingUserIds: number[] = [];
    
    // Collect all existing users from all roles, excluding the user being removed
    this.assignedRoles.forEach(role => {
      if (role.id === roleId) {
        // For the role containing the user, exclude the user being removed
        const existingUserIds = role.users
          .filter((roleUser: any) => roleUser.id !== user.id)
          .map((roleUser: any) => roleUser.id);
        allExistingUserIds.push(...existingUserIds);
      } else {
        // For other roles, keep all existing users
        const existingUserIds = role.users.map((roleUser: any) => roleUser.id);
        allExistingUserIds.push(...existingUserIds);
      }
    });
    
    const uniqueUserIds = Array.from(new Set(allExistingUserIds));
    
    const payload = [
      {
        user_id: uniqueUserIds
      }
    ];
    
    // Make API call to update role members
    this.jobService.addMembersToRole(this.eventId, roleId, payload).subscribe({
      next: (response: any) => {
        
        // Reload access management data to get updated state
        this.loadAccessManagementData();
        
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'User removed successfully'
        });
        
        this.closeDeleteMemberModal();
        this.isDeletingMember = false;
      },
      error: (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to remove user. Please try again.'
        });
        this.isDeletingMember = false;
      }
    });
  }

  getDefaultProfilePicture(user: any): string {
    // Generate a default profile picture URL based on user initials
    const initials = user.initials || 'U';
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=6944D6&color=ffffff&size=120&rounded=true`;
  }

  toggleUserSelection(userId: string) {
    if (this.selectedUsers.includes(userId)) {
      this.selectedUsers = this.selectedUsers.filter(id => id !== userId);
    } else {
      this.selectedUsers = [...this.selectedUsers, userId];
    }
    
    // Force change detection in the Angular zone
    this.ngZone.run(() => {
      this.cdr.detectChanges();
    });
  }

  getAttachmentName(attachment: string): string {
    if (!attachment) return '';
    return attachment.split('/').pop() || '';
  }

  trackByUserId(index: number, user: any): any {
    return user.id;
  }

  getAttachmentSize(attachment: string): string {
    // This would typically come from the API, for now return a placeholder
    return '2MB';
  }

  getHiringManagerName(location: any): string {
    if (!location || !location.hire_manager) return '';
    return `${location.hire_manager.first_name} ${location.hire_manager.last_name}`;
  }

  getLocationFieldValue(location: any, field: string): string {
    if (!location) return '';
    const value = location[field];
    // Allow 0 values, only return empty string for null/undefined
    return value !== null && value !== undefined ? value.toString() : '';
  }

  // Search filter methods for dropdowns
  filterCountries(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredCountries = this.countries.filter(country => 
      country.label.toLowerCase().includes(searchTerm)
    );
  }

  filterStates(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredStates = this.states.filter(state => 
      state.label.toLowerCase().includes(searchTerm)
    );
  }

  filterCities(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredCities = this.cities.filter(city => 
      city.label.toLowerCase().includes(searchTerm)
    );
  }

  onCountryChange(country: any) {
    if (this.isUserChangingCountry) {
      this.selectedState = null;
      this.selectedCity = null;
      // Reset state and city fields in the current location
      this.updateLocationField('state', '');
      this.updateLocationField('city', '');
    }
    
    this.states = [];
    this.cities = [];
    this.filteredStates = [];
    this.filteredCities = [];
    if (country && this.jsonData[country]) {
      this.states = Object.keys(this.jsonData[country]).map(state => ({
        label: state,
        value: state
      }));
      this.filteredStates = [...this.states];
    }
    this.jobRoleForm.markAsDirty();
    this.cdr.detectChanges();
    this.isUserChangingCountry = false;
  }

  loadCountryData(country: any) {

    this.states = [];
    this.cities = [];
    this.filteredStates = [];
    this.filteredCities = [];
    if (country && this.jsonData[country]) {
      this.states = Object.keys(this.jsonData[country]).map(state => ({
        label: state,
        value: state
      }));
      this.filteredStates = [...this.states];
    }
  }

  loadStateData(state: any, country: any) {
    this.cities = [];
    this.filteredCities = [];
    if (state && country && this.jsonData && this.jsonData[country] && this.jsonData[country][state]) {
      this.cities = this.jsonData[country][state].map((city: string) => ({
        label: city,
        value: city
      }));
      this.filteredCities = [...this.cities];
    }
  }

  onStateChange(state: any, country: any) {
    this.cities = [];
    this.filteredCities = [];
    if (state && country && this.jsonData && this.jsonData[country] && this.jsonData[country][state]) {
      this.cities = this.jsonData[country][state].map((city: string) => ({
        label: city,
        value: city
      }));
      this.filteredCities = [...this.cities];
    }
    this.jobRoleForm.markAsDirty();
    this.cdr.detectChanges();
  }

  loadLocationData() {
    if (this.locationDetails && this.locationDetails.length > 0) {
      const location = this.locationDetails[0];
      this.selectedCountry = location.country;
      this.selectedState = location.state;
      // Handle city as array - take first element if it's an array
      this.selectedCity = Array.isArray(location.city) ? location.city[0] : location.city;
      this.selectedBusinessUnit = location.business_unit || '';
      
      if (location.country) {
        this.onCountryChange(location.country);
        if (location.state) {
          this.onStateChange(location.state, location.country);
        }
      }
    }
  }

  // Location management methods
  addLocation() {
    if (!this.roleDetails.locations) {
      this.roleDetails.locations = [];
    }
    
    const newLocation = {
      id: null,
      country: '',
      state: '',
      city: '',
      business_unit: '',
      opening: 0,
      max_applicant: 0,
      diversity_male: 0,
      diversity_female: 0,
      diversity_other: 0,
      hire_manager_id: null
    };
    
    this.roleDetails.locations.push(newLocation);
    this.locationStates.push([]);
    this.locationCities.push([]);
    
    // Update selected location index to the new location
    this.selectedLocationIndex = this.roleDetails.locations.length - 1;
    this.locationDetails = [newLocation];
    
    // Clear current selections for the new location
    this.selectedCountry = null;
    this.selectedState = null;
    this.selectedCity = null;
    this.selectedBusinessUnit = '';
    this.states = [];
    this.cities = [];
  }

  removeLocation(index: number) {
    if (this.roleDetails.locations && this.roleDetails.locations.length > index) {
      this.roleDetails.locations.splice(index, 1);
      this.locationStates.splice(index, 1);
      this.locationCities.splice(index, 1);
      
      // Update selected location index
      if (this.roleDetails.locations.length === 0) {
        this.selectedLocationIndex = 0;
        this.locationDetails = [];
        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.selectedBusinessUnit = '';
        this.states = [];
        this.cities = [];
      } else {
        // If we removed the last location, select the previous one
        if (index >= this.roleDetails.locations.length) {
          this.selectedLocationIndex = this.roleDetails.locations.length - 1;
        } else {
          // Keep the same index, but the location at that index is now different
          this.selectedLocationIndex = index;
        }
        
        // Update the current location details
        this.locationDetails = [this.roleDetails.locations[this.selectedLocationIndex]];
        this.updateLocationFields();
      }
    }
  }

  updateLocationFields() {
    if (this.locationDetails && this.locationDetails.length > 0) {
      const location = this.locationDetails[0];
      this.selectedCountry = location.country;
      this.selectedState = location.state;
      this.selectedCity = Array.isArray(location.city) 
        ? location.city[0] 
        : location.city;
      this.selectedBusinessUnit = location.business_unit || '';
      
      // Load states and cities for the current location
      this.onCountryChange(this.selectedCountry);
      if (this.selectedState) {
        this.onStateChange(this.selectedState, this.selectedCountry);
      }
    }
  }

  onCountryChangeForLocation(country: any, locationIndex: number) {
    if (country && this.jsonData[country]) {
      this.locationStates[locationIndex] = Object.keys(this.jsonData[country]).map(state => ({
        label: state,
        value: state
      }));
      this.locationCities[locationIndex] = [];
      
      // Update the location object
      if (this.roleDetails.locations[locationIndex]) {
        this.roleDetails.locations[locationIndex].country = country;
        // Don't clear state and city if they're being set during initialization
        if (!this.roleDetails.locations[locationIndex].state) {
          this.roleDetails.locations[locationIndex].state = '';
        }
        if (!this.roleDetails.locations[locationIndex].city) {
          this.roleDetails.locations[locationIndex].city = '';
        }
      }
    }
  }

  onStateChangeForLocation(state: any, country: any, locationIndex: number) {
    if (state && country && this.jsonData && this.jsonData[country] && this.jsonData[country][state]) {
      this.locationCities[locationIndex] = this.jsonData[country][state].map((city: string) => ({
        label: city,
        value: city
      }));
      
      // Update the location object
      if (this.roleDetails.locations[locationIndex]) {
        this.roleDetails.locations[locationIndex].state = state;
        // Don't clear city if it's being set during initialization
        if (!this.roleDetails.locations[locationIndex].city) {
          this.roleDetails.locations[locationIndex].city = '';
        }
      }
    }
  }

  getStatesForLocation(locationIndex: number): Array<any> {
    return this.locationStates[locationIndex] || [];
  }

  getCitiesForLocation(locationIndex: number): Array<any> {
    return this.locationCities[locationIndex] || [];
  }

  async loadTinyMce() {
    await this.globalService.loadScript(
      'script',
      `https://cdn.tiny.cloud/1/${this.tinymce_api_key}/tinymce/8.0.2/tinymce.min.js`,
      'text/javascript',
      'examlyck'
    );
    tinymce.remove();
    tinymce
      .init({
        selector: 'textarea[id="event-details-description-editor"]',
        content_style: "@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap'); body { font-family: Poppins; }",
        height: 300,
        content_css_cors: true,
        content_css: true,
        menubar: 'file edit view insert format tools table help',
        plugins: 'preview searchreplace autolink directionality code visualblocks visualchars fullscreen link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help quickbars emoticons save autoresize image',
        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media link anchor codesample | ltr rtl',
        toolbar_sticky: true,
        toolbar_mode: 'wrap',
        images_upload_url: '',
        image_caption: true,
        image_title: true,
        automatic_uploads: true,
        file_picker_types: 'image',
        quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
        quickbars_insert_toolbar: 'quickimage quicktable',
        noneditable_noneditable_class: 'mceNonEditable',
        contextmenu: 'link image imagetools table',
        relative_urls: false,
        convert_urls: false,
        branding: false,
        deprecation_warnings: false,
        paste_as_text: false,
        paste_auto_cleanup_on_paste: true,
        textpattern_patterns: [
          {start: '*', end: '*', format: 'italic'},
          {start: '**', end: '**', format: 'bold'},
          {start: '#', format: 'h1'},
          {start: '##', format: 'h2'},
          {start: '###', format: 'h3'},
          {start: '1. ', cmd: 'InsertOrderedList'},
          {start: '* ', cmd: 'InsertUnorderedList'},
          {start: '- ', cmd: 'InsertUnorderedList'}
        ],
        min_height: 300,
        max_height: 300,
        autoresize_bottom_margin: 0,
        autoresize_overflow_padding: 0,
        setup: (editor: any) => {
          editor.on('init', () => {
            if (this.roleDetails && this.roleDetails.description) {
              editor.setContent(this.roleDetails.description);
            }
          });
          editor.on('change keyup', () => {
            const content = editor.getContent();
            this.jobRoleForm.patchValue({ description: content });
          });
        }
      })
      .catch((error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Editor Error',
          detail: 'Failed to initialize the rich text editor. Please refresh and try again.'
        });
      });
  }

  syncDescriptionEditorContent() {
    if (typeof tinymce === 'undefined') {
      return;
    }
    const editor = tinymce.get('event-details-description-editor');
    if (editor && editor.initialized) {
      editor.setContent(this.roleDetails?.description || '');
    }
  }

  editDescription() {
    this.editingDescription.set(true);
    setTimeout(() => {
      this.loadTinyMce();
    }, 100);
  }

  cancelEditDescription() {
    this.editingDescription.set(false);
    if (typeof tinymce !== 'undefined') {
      tinymce.remove();
    }
  }
  resetOverviewForm() {
    this.eventDetailsForm.reset();
    this.populateFormWithInstitutions();
    this.hasFormChanges = false;
  }

  resetJobRoleForm() {
    this.jobRoleForm.reset();
    this.populateJobRoleForm();
    this.hasJobRoleChanges = false;
  }

  decodeHTML(html: string): string {
    const el = document.createElement('div');
    el.innerHTML = html;
    return el.textContent || el.innerText || '';
  }

  private async validateEmailTemplate(): Promise<boolean> {
    const templateId = this.eventDetailsForm.get('email_template_id')?.value;

    if (!templateId) return true;

    try {
      const response = await this.emailServices.getSpecificTemplateFastApi(templateId).toPromise();

      if (response && response.status === 200 && response.body) {
        const rawBody = response.body.body || '';
        const decodedBody = this.decodeHTML(rawBody);
        const hasLinkPlaceholder = decodedBody.includes('${link}') || decodedBody.includes('{link}');      
        
        if (!hasLinkPlaceholder) {
          this.messageService.add({
            severity: 'error',
            summary: 'Invalid Template',
            detail: 'The selected email template does not contain the required ${link} placeholder. Please choose a valid template.'
          });
          return false;
        }
      }
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Unable to validate the selected email template.'
      });
      return false;
    }

    return true;
  }

  canSaveEventDetails(): boolean {
    if (!this.hasFormChanges) {
      return false;
    }
    if (!this.eventDetailsForm.valid) {
      return false;
    }
    const selectedEventType = this.getSelectedEventType();
    if (selectedEventType?.institution_select_type === 'single' || selectedEventType?.institution_select_type === 'multiple') {
      const institutionName = this.eventDetailsForm.get('institutionName')?.value;
      const institutionAddress = this.eventDetailsForm.get('institutionAddress')?.value;
      const institutionNameValid = institutionName && 
        (Array.isArray(institutionName) ? institutionName.length > 0 : institutionName);
      const institutionAddressValid = institutionAddress && institutionAddress.trim() !== '';
      if (!institutionNameValid || !institutionAddressValid) {
        return false;
      }
    }
    return true;
  }
}
